import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateDriverSearch = () => {
  const corporateDriverSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/driver/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporateDriverSearch }
}

export default InteractorCorporateDriverSearch
